import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function SKU ({ localSKUS, setLocalSKUS, isQueryLoading }) {
  const handleSKUSChange = event => {
    setLocalSKUS(event.target.value)
  }

  return (
    <div className={styles.SKUContainerPeople}>
      <div className={styles.inlineLabel}>
        <label className={styles.SKUPeopleLabel} htmlFor='SKU'>
          SKU
        </label>
        <Tooltip
          title='Filter by the stock keeping unit (SKU) assigned by a retailer or seller.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='SKU help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.SKUInputPeople}
        disabled={isQueryLoading}
        placeholder='Text'
        onChange={handleSKUSChange}
        value={localSKUS}
        type='text'
      />
    </div>
  )
}

export default SKU
